import { defineMessages } from 'react-intl';

const messages = defineMessages({
  emptyList: {
    id: 'dossier.cardList.emptyList',
    defaultMessage: 'Aucun dossier disponible.',
  },
  emptySearch: {
    id: 'dossier.cardList.emptySearch',
    defaultMessage: 'Aucun dossier ne correspond à votre recherche.',
  },
  emptyFilter: {
    id: 'dossier.cardList.emptyFilter',
    defaultMessage: 'Aucun dossier ne correspond à ce statut.',
  },
  emptySearchAndFilter: {
    id: 'dossier.cardList.emptySearchAndFilter',
    defaultMessage: 'Aucun dossier ne correspond à votre recherche et à ce statut.',
  },
});

export default messages;
